@if (site) {
  <mat-accordion>
    <!-- Storage Panel -->
    <mat-expansion-panel [expanded]="storageEnabled">
      <mat-expansion-panel-header>
        <div class="flex items-center">
          <h2 style="margin-right: 1rem">Storage</h2>
          <fa-icon [icon]="circle" class="dirty" *ngIf="storageDirty" matTooltip="Storage Devices are not saved"></fa-icon>
          <fa-icon [icon]="circle" class="clean" *ngIf="!storageDirty" matTooltip="Storage Devices Saved"></fa-icon>
        </div>
      </mat-expansion-panel-header>
      <div class="row" *ngIf="!storageEnabled && storageDevices">
          <div *ngFor="let deviceTitle of storageDeviceTitle">
            {{deviceTitle}}
          </div>
      </div>
      <app-site-storage (formDirty)="toggleStoragePanel($event)" [site]="site"></app-site-storage>
    </mat-expansion-panel>

    <!-- Solar Panel -->
    <mat-expansion-panel [expanded]="solarDevicesEnabled">
      <mat-expansion-panel-header>
        <div class="flex items-center">
          <h2 style="margin-right: 1rem">Solar</h2>
          <fa-icon [icon]="circle" class="dirty" *ngIf="solarDirty" matTooltip="Solar Devices are not saved"></fa-icon>
          <fa-icon [icon]="circle" class="clean" *ngIf="!solarDirty" matTooltip="Solar Devices Saved"></fa-icon>
        </div>
      </mat-expansion-panel-header>
      <div class="row" *ngIf="!solarDevicesEnabled">
        <div class="col-4" *ngIf="solarDevices">
          {{solarDeviceTitle.join(', ')}}
        </div>
      </div>
      <app-site-solar (formDirty)="toggleSolarPanel($event)" [site]="site"></app-site-solar>
    </mat-expansion-panel>

    <!-- Other Devices Panel -->
    <mat-expansion-panel [expanded]="otherDevicesEnabled">
      <mat-expansion-panel-header>
        <div class="flex items-center">
          <h2 style="margin-right: 1rem">Other</h2>
          <fa-icon [icon]="circle" class="dirty" *ngIf="otherDirty" matTooltip="Other Devices are not saved"></fa-icon>
          <fa-icon [icon]="circle" class="clean" *ngIf="!otherDirty" matTooltip="Other Devices Saved"></fa-icon>
        </div>
      </mat-expansion-panel-header>
      <div class="row" *ngIf="!otherDevicesEnabled">
        <div class="col-4" *ngIf="otherDevices">
          {{otherDeviceTitle.join(', ')}}
        </div>
      </div>
      <app-site-other-devices (formDirty)="toggleOtherPanel($event)" [site]="site"></app-site-other-devices>
    </mat-expansion-panel>
  </mat-accordion>
} @else {
  <div class="flex items-center justify-center">
    <span style="margin-top: 5rem">No data to show</span>
  </div>
}
